
    var runtime = require('vue-svg-component-runtime')
    module.exports = {
      __esModule: true,
      default: runtime.svgComponent({
  "tag": "svg",
  "attrsMap": {
    "xmlns": "http://www.w3.org/2000/svg",
    "xmlns:xlink": "http://www.w3.org/1999/xlink",
    "width": "14px",
    "height": "17px"
  },
  "children": [
    {
      "tag": "path",
      "attrsMap": {
        "fill-rule": "evenodd",
        "fill": "rgb(148, 155, 174)",
        "d": "M12.000,16.063 L2.000,16.063 C0.895,16.063 0.000,15.167 0.000,14.063 L0.000,9.063 C0.000,7.958 0.895,7.063 2.000,7.063 L3.000,7.063 L3.000,4.063 C3.000,1.853 4.791,0.063 7.000,0.063 C9.209,0.063 11.000,1.853 11.000,4.063 L11.000,7.063 L12.000,7.063 C13.104,7.063 14.000,7.958 14.000,9.063 L14.000,14.063 C14.000,15.167 13.104,16.063 12.000,16.063 ZM7.000,12.063 C7.552,12.063 8.000,11.615 8.000,11.063 C8.000,10.510 7.552,10.063 7.000,10.063 C6.448,10.063 6.000,10.510 6.000,11.063 C6.000,11.615 6.448,12.063 7.000,12.063 ZM9.000,4.063 C9.000,2.958 8.105,2.063 7.000,2.063 C5.896,2.063 5.000,2.958 5.000,4.063 L5.000,7.063 L9.000,7.063 L9.000,4.063 Z"
      }
    }
  ]
})
    }
  